<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'department', 'com_name', 'writer_name', 'date']" />
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t("사업장 순회점검에 의한 유해·위험요인 조사표") }}</h5>

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>{{ $t("실시방법") }}</div>
          <p v-if="isPrint" class="print-textarea">{{ form.실시방법 }}</p>
          <ml-textarea v-else rows="5" v-model="form.실시방법" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("수행자 성명") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.수행자성명 }}</p>
          <ml-input v-else class="w-full flex-1" v-model="form.수행자성명" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("수행일") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.수행일 }}</p>
          <date-selector v-else v-model="form.수행일" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("수행시간") }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.수행시간.sTime }} ~ {{ form.수행시간.eTime }}</p>
          <time-selector-rang v-else :readonly="board.readonly" v-model="form.수행시간" />
        </div>
      </div>

      <HazardWorkTable v-model="form.유해위험작업" :readonly="board.readonly" :is-print="isPrint" class="mt-8" />

      <!--    사진대지-->
      <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" :section-title="$t('사업장 순회점검 활동사진')" :placeholder="$t('사업장 순회점검 활동사진')" />

      <AttendeeTableTwoColumn v-model="form.순회점검자명단" :board="board" :is-print="isPrint" class="mt-28px" :title="$t('순회점검자 명단')" />

      <file-upload-module v-if="!isPrint" v-model="form.fileList" class="w-full" :isPrint="isPrint" :readonly="board.readonly" />
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import AttendeeTableTwoColumn from "@/components/AttendeeTableTwoColumn.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";
import HazardWorkTable from "@/views/boards/single-page/1153/HazardWorkTable.vue";

export default {
  components: {
    TimeSelectorRang,
    AttendeeTableTwoColumn,
    DateSelectorRang,
    RadioGroup,
    FileUploadModule,
    HazardWorkTable,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {},
  data() {
    return {
      form: {
        stdInfo: {},
        실시방법: "",
        수행자성명: "",
        수행일: "",
        수행시간: {},

        유해위험작업: [],
        photoList: [],
        순회점검자명단: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    isMobile() {
      return this.$store.state.windowWidth <= 768;
    },
  },
  methods: {

  },
};
</script>
